<div class="favorites">
    <div class="row">
        <div class="col favorites-container">
            <div class="fav-title">{{consts.TITLE}}</div>
                <div class="tools-link-container">
                    <ng-container *ngIf="(favList$ | async) as list" >
                        <div *ngIf="list.length > 0" class="tools">
                            <div class="text" *ngFor="let tools of list">
                                <span (click)="openLink(tools.link)">
                                    {{tools.name}}
                                </span>
                            </div>
                        </div>
                        <div *ngIf="list.length === 0">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 fav-empty">
                                    <h2>{{consts.LABEL_NO_FAVORITES}}</h2>
                                    <h4>{{consts.LABEL_GO_TO_FAVORITES}}</h4>
                                    <mat-icon svgIcon="hub_fav_empty"></mat-icon>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
        </div>
    </div>
    <div class="row">
        <div class="col button-manage-fav">
            <a (click)="viewAll()">{{consts.BUTTON_MANAGE}}</a>
        </div>
    </div>
</div>
